import React, { FC } from 'react';

import { PlayerApiError } from '@/scenarios/legacy-player/types/error';
import { ReadonlySource } from '@/scenarios/legacy-player/types/config';

import { PlayerTracker } from '../../player-tracker/component';
import { getTimingsInterval } from '../../../../player-config/helpers/get-timings-interval';
import { useConcurrencyArbiter } from '../../../hooks/concurrency-arbiter/use-concurrency-arbiter';

import { FilmPlayerController } from './VodPlayerControllerProps';
import { FilmPlayerTracker } from './FilmPlayerTracker';
import { FilmPlayerView } from './FilmPlayerView';

interface FilmPlayerProps {
    contentId: string;
    psid: string;
    onContentImpression: () => void;
    onSourceChanged?: (newSource: ReadonlySource | undefined) => void;
    onFinish?: () => void;
    onError?: (error: PlayerApiError) => void;
    onClose?: () => void;
    onWatchedTimeChanged: (watchedTime: number) => void;
    concurrencyArbiterConfig?: Parameters<typeof useConcurrencyArbiter>[0]['config'];
}

export const FilmPlayer: FC<FilmPlayerProps> = ({
    contentId,
    concurrencyArbiterConfig,
    psid,
    onError,
    onSourceChanged,
    onContentImpression,
    onFinish,
    onClose,
    onWatchedTimeChanged,
}) => {
    useConcurrencyArbiter({
        config: concurrencyArbiterConfig,
    });

    return (
        <PlayerTracker>
            <FilmPlayerController
                contentId={contentId}
                tvSeriesId={contentId}
                timingsInterval={getTimingsInterval()}
                onContentImpression={onContentImpression}
                onFinish={onFinish}
                onError={onError}
                onSourceChanged={onSourceChanged}
                onWatchedTimeChanged={onWatchedTimeChanged}
            />
            <FilmPlayerTracker contentId={contentId} psid={psid} />

            <FilmPlayerView contentId={contentId} onClose={onClose} />
        </PlayerTracker>
    );
};
